import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import InvoicePaymentService from "../../Controller/InvoicePaymentController";
import CreateInvoicePayment from "./CreateInvoicePayment";
import HelpSite from "../../../Common/HelpLink";
import InvoiceService from "../../Controller/InvoiceController";
function InvoicePaymentPage({ InvoiceID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    InvoiceID = localStorage.getItem('InvoiceID');


    const [InvoicePaymentList, setInvoicePayment] = useState([]);

    const [modalInstance, setModalInstance] = useState(null);
    const [currentInvoicePayment, setCurrentInvoicePayment] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isClosed, SetIsClosed] = useState("0");
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const fetchInvoicePayment = async () => {
        try {
            const data = await InvoicePaymentService.GetAllInvoicePayment(redirectCallback, InvoiceID);
            setInvoicePayment(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    const fetchInvoiceDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (InvoiceID > 0) {
                const saleOrderDetail = await InvoiceService.GetInvoiceByID(redirectCallback, InvoiceID);
                const saleOrder = saleOrderDetail[0];
                if (saleOrder.bit_DropShipment > 0 || saleOrder.bit_DropShipmentc > 0) {
                    SetIsClosed("1");
                }
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    useEffect(() => {
        SetIsClosed("0");
        fetchInvoiceDetail();
        fetchInvoicePayment();
    }, [InvoiceID]);

    const handleCreateInvoiceNotesClick = () => {
        setCurrentInvoicePayment(null);
        fetchInvoicePayment();
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (payment) => {
        setCurrentInvoicePayment(payment);
        fetchInvoicePayment();
        setIsModalOpen(true);
    };
    const handleSuccess = () => {
        fetchInvoicePayment();// Refresh the list after submission
        handleCloseModal();   // Close the modal
    };

    const handleDeleteClick = async (ID, redirectCallback) => {
        const confirmed = window.confirm("Are you sure you want to delete this contact?");
        if (confirmed) {
            try {
                await InvoicePaymentService.DeleteInvoicePayment(ID, redirectCallback);
                fetchInvoicePayment(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Contact:', error);
            }
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateInvoiceNotesClick} disabled={isClosed === '1' || isClosed === 1}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Method</th>
                                    <th>Reference</th>
                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {InvoicePaymentList.map((payment) => (
                                    <tr key={payment.PK_SalesOrderPayment_ID} onClick={() => handleEditClick(payment)} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                        <td>{formatDate(payment.dt_PaymentDate)}</td>
                                        <td>{payment.mon_Amount}</td>
                                        <td>{payment.snt_PaymentType}</td>
                                        <td>{payment.Reference}</td>


                                        <td style={{ "textAlign": "right" }}>

                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteClick(payment.PK_InvoicePayment_ID)} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreateInvoicePayment
                    modalInstance={modalInstance}
                    currentInvoicePayment={currentInvoicePayment}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}

                    InvoiceID={InvoiceID}


                />
            )}
        </div>
    );
}

export default InvoicePaymentPage;
